import { ref, Ref } from 'vue'
import type { Stripe } from '@stripe/stripe-js'

export type StripeModuleI = {
  initStripeInstance: (api_key: string) => Promise<void>
  getIntentToken: () => string | null
  getStripeInstance: () => Stripe | null
  setIntentToken: (intent_token: string | null) => void
}

export default function useStripeModule(): StripeModuleI {
  const stripeInstance: Ref<Stripe | null> = ref(null)
  const intentToken: Ref<string | null> = ref(null)
  async function initStripeInstance(api_key: string) {
    const { loadStripe } = await import('@stripe/stripe-js')
    stripeInstance.value = await loadStripe(api_key)
  }
  function setIntentToken(intent_token: string | null) {
    intentToken.value = intent_token
  }
  function getIntentToken() {
    return intentToken.value
  }
  function getStripeInstance() {
    return stripeInstance.value
  }
  return {
    initStripeInstance,
    getStripeInstance,
    setIntentToken,
    getIntentToken,
  }
}
